import {Params} from '@angular/router';
import {normalizeProductQueryParams, ProductQueryParamsInput} from '../models';
import {PagedApiResponse} from '../models/clare';

type ListParams = Params | ProductQueryParamsInput;

export function isActiveListSearch(params: ListParams): boolean {
  const query = (params as ProductQueryParamsInput).query;
  const normalized = normalizeProductQueryParams(params as ProductQueryParamsInput);
  const hasQuery = typeof query === 'string' ? query.trim().length > 0 : !!query;

  return hasQuery || normalized.active !== undefined || normalized.catalogId !== undefined;
}

export function isFirstListPage(params: ListParams): boolean {
  return normalizeProductQueryParams(params as ProductQueryParamsInput).page === 1;
}

export function isNotFoundError(error: unknown): boolean {
  return typeof error === 'object' && error !== null && (error as {status?: unknown}).status === 404;
}

export function emptyPagedListResponse<T>(params: ListParams, resultType: string): PagedApiResponse<T> {
  const normalized = normalizeProductQueryParams(params as ProductQueryParamsInput);
  return {
    metadata: {
      result_type: resultType,
      pagination: {
        current_page: normalized.page,
        limit: normalized.take ?? 10,
        total: 0,
        total_pages: 0,
      },
    },
    result: [],
    error: {},
  };
}
